import Vue from 'vue'

const unUi = new Vue()

const PROMPT_USER_FOR_IMAGE_FILE_EVENT = 'promptUserForImageFile'
const REVEAL_INTRO_EVENT = 'revealIntro'
const HIDE_INTRO_EVENT = 'hideIntro'

const RENDER_START_EVENT = 'render-start'
const RENDER_COMPLETE_EVENT = 'render-complete'

const ALERT_USER_EVENT = 'alert-user'

export {
  ALERT_USER_EVENT,
  HIDE_INTRO_EVENT,
  PROMPT_USER_FOR_IMAGE_FILE_EVENT,
  RENDER_COMPLETE_EVENT,
  RENDER_START_EVENT,
  REVEAL_INTRO_EVENT,
  unUi
}



// WEBPACK FOOTER //
// ./uncommon-client/components/EventBuses.js